import {Alert, Button, Group, Stack, Text} from '@mantine/core'

type TruckDriverBillingAlertProps = {
    message: string
    onContinue: () => void
    onGoBack: () => void
    loading?: boolean
}

export function TruckDriverBillingAlert({
    message,
    onContinue,
    onGoBack,
    loading = false,
}: TruckDriverBillingAlertProps) {
    return (
        <Alert color="yellow" title="Billing warning" data-testid="truck-driver-billing-warning">
            <Stack gap="sm">
                <Text size="sm">{message}</Text>
                <Group gap="sm">
                    <Button size="xs" onClick={onContinue} loading={loading}>
                        Continue
                    </Button>
                    <Button size="xs" variant="default" onClick={onGoBack} disabled={loading}>
                        Go back
                    </Button>
                </Group>
            </Stack>
        </Alert>
    )
}
